import { action, observable, computed, runInAction, reaction } from 'mobx';

export default class ReqStore {
  @observable processing = false;
  @observable penddingActions = [];

  constructor() {
    const store = this;
    reaction(
      () => store.hasPenddingActions,
      () => {
        if (store.hasPenddingActions) {
          store.penddingActions.shift();
        }
      },
      {
        fireImmediately: false,
        delay: 10000,
      }
    );
  }

  @computed get hasPenddingActions() {
    return this.processing || this.penddingActions.length > 0;
  }

  @action async start(asyncAction) {
    try {
      this.processing = true;
      const response = await asyncAction();
      runInAction(() => {
        this.process(response);
      });
    } finally {
      runInAction(() => {
        this.processing = false;
      });
    }
  }

  @action process(response) {
    if (!response || !response.result || !response.result.successful) {
      return;
    }
    const { command } = response;
    if (!!command && !!command.correlationId) {
      this.penddingActions.push(command.correlationId);
    }
  }

  @action done(correlationId) {
    this.penddingActions.remove(correlationId);
  }

  @action clear() {
    this.penddingActions.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/LoadingScreenStore.js